(function () {
  function currentTheme() {
    return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }
  function updateOptionState(theme) {
    document.querySelectorAll('[data-mayi-theme-set]').forEach(function (btn) {
      var isActive = btn.getAttribute('data-mayi-theme-set') === theme;
      btn.classList.toggle('mayi-theme-option--active', isActive);
      btn.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem('mayi-theme', theme);
    } catch (e) {}
    document.querySelectorAll('[data-mayi-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
    });
    updateOptionState(theme);
  }
  // Ferme le menu « Affichage » dès qu'un mode est choisi :
  // menu déroulant de l'en-tête (ordinateur) ou menu tiroir (mobile).
  function closeMenu(btn, event) {
    var drawer = btn.closest('header-drawer, menu-drawer');
    if (drawer && typeof drawer.closeMenuDrawer === 'function') {
      // l'en-tête de Dawn ne ferme le tiroir que si on lui indique où
      // replacer le focus : le bouton « menu » (hamburger).
      var toggle = drawer.querySelector('summary');
      drawer.closeMenuDrawer(event, toggle);
      // 30 oct : Dawn ne remet aria-expanded à "false" que pour une
      // fermeture au clavier. Au doigt (téléphone, tablette), le bouton
      // restait "ouvert" et le voile semi-transparent du menu (posé sous
      // l'en-tête) restait affiché sur la page après le changement de
      // mode, jusqu'à un nouveau toucher. On le remet donc à "false".
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      btn.blur();
      return;
    }
    var disclosure = btn.closest('header-menu, details-disclosure');
    if (disclosure && typeof disclosure.close === 'function') {
      disclosure.close();
    } else {
      var details = btn.closest('details[open]');
      if (details) {
        details.removeAttribute('open');
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    }
    btn.blur();
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mayi-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', currentTheme() === 'dark' ? 'true' : 'false');
      btn.addEventListener('click', function () {
        applyTheme(currentTheme() === 'dark' ? 'light' : 'dark');
      });
    });

    document.querySelectorAll('[data-mayi-theme-set]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        applyTheme(btn.getAttribute('data-mayi-theme-set'));
        closeMenu(btn, event);
      });
    });

    updateOptionState(currentTheme());
  });

  /* Fenêtre « Se connecter ou créer un compte » (fournie par Shopify).
     Ses éléments sont enfermés dans le composant Shopify : on y ajoute
     de petites feuilles de style au moment où la fenêtre s'ouvre.
     - Champ e-mail : contour bleu lagon (comme le formulaire de
       contact), adresse saisie dorée.
     - Boutons « Commandes » et « Profil » : chacun sa couleur (bleu
       lagon / or ylang) en teinte légère, remplis de leur couleur au
       survol et au clavier.
     - 30 oct : bouton de fermeture = même croix que partout sur le site :
       croix épaisse sans cercle (deux barres ::before/::after de
       18 x 2,4 px croisées à 45°, l'icône fine d'origine est masquée),
       centrée verticalement sur la ligne du titre. Couleurs : variables
       --mayi-acc-close* (mayi-header-icons.css).
     - 30 oct : tant que la fenêtre est ouverte, le pictogramme « Mon
       compte » de l'en-tête porte la classe .mayi-account-open (effet
       loupe en mode sombre, voir mayi-header-icons.css).
     Les couleurs viennent de mayi-header-icons.css (variables
     --mayi-login-* et --mayi-acc-*), donc elles suivent le mode
     clair/sombre. Si Shopify change son composant, rien ne casse : les
     éléments gardent simplement leur style d'origine. */
  var loginCss =
    '.login-form__email-input{border-color:var(--mayi-login-border,var(--shopify-login-form-color-border))!important;' +
    'color:var(--mayi-login-text,var(--shopify-login-form-color-control-text))!important;' +
    'caret-color:var(--mayi-login-text,currentColor);font-weight:500;' +
    'transition:border-color .2s ease,box-shadow .2s ease}' +
    '.login-form__email-input:-webkit-autofill{-webkit-text-fill-color:var(--mayi-login-text,currentColor)}' +
    '.login-form__email-input:hover{border-color:var(--mayi-login-border-focus,var(--shopify-login-form-color-text))!important}' +
    '.login-form__email-input:focus,.login-form__email-input:focus-visible{' +
    'border-color:var(--mayi-login-border-focus,var(--shopify-login-form-color-text))!important;' +
    'box-shadow:0 0 0 1px var(--mayi-login-border-focus,transparent),0 0 .8rem var(--mayi-login-glow,transparent)}';
  var accountCss =
    '.stack-inline>a.button.outline{transition:background-color .2s ease,color .2s ease,border-color .2s ease,box-shadow .2s ease;' +
    'border:1px solid var(--mayi-acc-a-border,currentColor)!important;background-color:var(--mayi-acc-a-bg,transparent)!important;' +
    'color:var(--mayi-acc-a-text,inherit)!important;font-weight:500}' +
    '.stack-inline>a.button.outline[href*="/profile"]{border-color:var(--mayi-acc-b-border,currentColor)!important;' +
    'background-color:var(--mayi-acc-b-bg,transparent)!important;color:var(--mayi-acc-b-text,inherit)!important}' +
    '.stack-inline>a.button.outline:hover,.stack-inline>a.button.outline:focus-visible{' +
    'background-color:var(--mayi-acc-a-border,transparent)!important;color:var(--mayi-acc-hover-text,inherit)!important;' +
    'box-shadow:0 .3rem .9rem var(--mayi-acc-a-glow,transparent)}' +
    '.stack-inline>a.button.outline[href*="/profile"]:hover,.stack-inline>a.button.outline[href*="/profile"]:focus-visible{' +
    'background-color:var(--mayi-acc-b-border,transparent)!important;color:var(--mayi-acc-hover-text,inherit)!important;' +
    'box-shadow:0 .3rem .9rem var(--mayi-acc-b-glow,transparent)}' +
    '.account__close{position:relative!important;box-sizing:border-box;width:24px!important;height:24px!important;' +
    'min-width:24px;min-height:24px;padding:0!important;border:0!important;border-radius:0!important;' +
    'align-self:center!important;margin-top:0!important;margin-bottom:0!important;' +
    'display:inline-flex!important;align-items:center;justify-content:center;overflow:visible;' +
    'background:transparent!important;color:var(--mayi-acc-close,#196b79)!important;box-shadow:none!important;' +
    'transition:color .2s ease}' +
    '.account__close svg{display:none!important}' +
    '.account__close::before,.account__close::after{content:""!important;display:block!important;position:absolute!important;' +
    'left:50%!important;top:50%!important;right:auto!important;bottom:auto!important;width:18px!important;height:2.4px!important;' +
    'margin:0!important;padding:0!important;border:0!important;border-radius:1px!important;box-shadow:none!important;opacity:1!important;' +
    'background:currentColor!important}' +
    '.account__close::before{transform:translate(-50%,-50%) rotate(45deg)!important}' +
    '.account__close::after{transform:translate(-50%,-50%) rotate(-45deg)!important}' +
    '.account__close:hover,.account__close:focus-visible{background:transparent!important;color:var(--mayi-acc-close-hover,#b88a44)!important}' +
    '@media (prefers-reduced-motion:reduce){.stack-inline>a.button.outline,.account__close{transition:none}}';
  function addSheet(root, css) {
    if (!root || root.__mayiStyled || !('adoptedStyleSheets' in root)) return;
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(css);
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
      root.__mayiStyled = true;
    } catch (e) {}
  }
  function styleLoginForm(root, depth) {
    if (!root || depth > 4) return false;
    var found = false;
    root.querySelectorAll('*').forEach(function (el) {
      if (!el.shadowRoot) return;
      if (el.tagName.toLowerCase() === 'shopify-login-form') {
        found = true;
        addSheet(el.shadowRoot, loginCss);
      } else if (styleLoginForm(el.shadowRoot, depth + 1)) {
        found = true;
      }
    });
    return found;
  }
  function watchAccount(account) {
    addSheet(account.shadowRoot, accountCss);
    var tries = 0;
    (function retry() {
      if (styleLoginForm(account.shadowRoot, 0) || tries++ > 40) return;
      setTimeout(retry, 150);
    })();
  }
  function trackAccountOpen(account) {
    var root = account.shadowRoot;
    if (!root || account.__mayiOpenTracked || !window.MutationObserver) return;
    account.__mayiOpenTracked = true;
    function sync() {
      account.classList.toggle('mayi-account-open', !!root.querySelector('dialog[open]'));
    }
    new MutationObserver(sync).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
    sync();
  }
  function initAccount() {
    document.querySelectorAll('shopify-account').forEach(function (account) {
      watchAccount(account);
      trackAccountOpen(account);
      account.addEventListener('click', function () {
        watchAccount(account);
        trackAccountOpen(account);
      });
    });
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-account').then(initAccount);
  }

  /* 30 oct : adresse e-mail de contact (hello@mayiilang.com) mise en
     valeur et cliquable partout (pages, politiques Shopify, fiches
     produits, onglets) : chaque adresse en @mayiilang.com écrite en
     texte devient un lien vers la page Contact (/pages/contact) ; sur
     la page Contact elle-même, le lien descend jusqu'au formulaire.
     Le style (couleur, icône enveloppe) est dans mayi-header-icons.css
     (classe .mayi-email). Les champs de saisie, boutons et liens
     existants ne sont pas touchés. */
  var MAIL_RE = /([A-Za-z0-9._%+-]+@mayiilang\.com)/g;
  var MAIL_SKIP = { A: 1, SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, BUTTON: 1, SELECT: 1, OPTION: 1, NOSCRIPT: 1, TITLE: 1, LABEL: 1 };
  function contactHref() {
    var onContact = /^\/pages\/contact\/?$/.test(location.pathname);
    var form = document.getElementById('ContactForm') || document.querySelector('form.contact, form[id*="contact" i]');
    if (onContact && form) {
      if (!form.id) form.id = 'ContactForm';
      return '#' + form.id;
    }
    return '/pages/contact';
  }
  function linkEmails(root) {
    if (!root || !document.createTreeWalker) return;
    var href = contactHref();
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || node.nodeValue.indexOf('@mayiilang.com') === -1) return NodeFilter.FILTER_REJECT;
        for (var p = node.parentNode; p && p.nodeType === 1; p = p.parentNode) {
          if (MAIL_SKIP[p.tagName] || p.isContentEditable) return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var found = [];
    var node;
    while ((node = walker.nextNode())) found.push(node);
    found.forEach(function (textNode) {
      var text = textNode.nodeValue;
      var frag = document.createDocumentFragment();
      var last = 0;
      var m;
      MAIL_RE.lastIndex = 0;
      while ((m = MAIL_RE.exec(text))) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var a = document.createElement('a');
        a.href = href;
        a.className = 'mayi-email';
        a.textContent = m[1];
        a.setAttribute('aria-label', 'Nous contacter (' + m[1] + ')');
        frag.appendChild(a);
        last = m.index + m[1].length;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
    });
    root.querySelectorAll('a[href^="mailto:"][href*="@mayiilang.com"]').forEach(function (a) {
      a.classList.add('mayi-email');
      a.setAttribute('href', href);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { linkEmails(document.body); });
  } else {
    linkEmails(document.body);
  }

  /* 30 oct : carrousels photo (bloc « Notre histoire / Nos créations »
     et bloc « Nos nouvelles collections », classe .mayi-story__carousel) :
     les flèches ← → ne sont plus au milieu de la photo (elles
     cachaient le motif du t-shirt) mais en bas, à la même hauteur que la
     barre de points, de part et d'autre. La position est recalculée à
     chaque changement de taille du carrousel (rotation de l'écran,
     chargement des photos), sur téléphone, tablette et ordinateur. */
  function alignArrows(carousel) {
    var dots = carousel.querySelector('.mayi-story__dots');
    var arrows = carousel.querySelector('.mayi-story__arrows');
    if (!dots || !arrows) return;
    var c = carousel.getBoundingClientRect();
    var d = dots.getBoundingClientRect();
    if (!c.height || !d.height) return;
    var mid = d.top + d.height / 2 - c.top;
    arrows.style.setProperty('top', mid.toFixed(1) + 'px', 'important');
    arrows.style.setProperty('bottom', 'auto', 'important');
  }
  function initArrows() {
    var list = document.querySelectorAll('.mayi-story__carousel');
    list.forEach(function (carousel) {
      alignArrows(carousel);
      if (window.ResizeObserver && !carousel.__mayiArrows) {
        carousel.__mayiArrows = true;
        new ResizeObserver(function () { alignArrows(carousel); }).observe(carousel);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArrows);
  } else {
    initArrows();
  }
  window.addEventListener('load', initArrows);
  window.addEventListener('resize', initArrows);
  document.addEventListener('shopify:section:load', initArrows);
})();
